import React, { ReactElement, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { LiveProps } from '../../LiveContainer';
import './LiveTerm.scss';
import { useSetTermsAgreementDateMutation } from '../../../../services/api/apiProvider';

export const LiveTerm = (props: LiveProps): ReactElement => {
  const history = useHistory();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [setTermsAgreementDate] = useSetTermsAgreementDateMutation();

  const handleClose = () => {
    history.push('/');
  };

  const handleAgree = () => {
    props.toggleTermModal(false);
    props.toggleGuidelineModal(true);
    setTermsAgreementDate();
  };

  // set iframe's height based on its content height
  const handleIframeOnload = () => {
    const iframe = iframeRef.current;
    const iframeDocument = iframe?.contentWindow?.document.documentElement;
    const iframeContentHeight = iframeDocument?.scrollHeight || 0;
    iframe?.style.setProperty('height', iframeContentHeight + 'px');
  };

  return (
    <Modal
      show={props.liveState.isShowTermModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="live-term__modal-dialog"
      contentClassName="live-term__modal-content"
      scrollable={true}
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body>
        <iframe
          onLoad={handleIframeOnload}
          className="live-term__iframe"
          src={'/files/about-streaming.html'}
          ref={iframeRef}
        ></iframe>
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: 'center' }}>
        <div className="text-center">
          <Button variant="primary" onClick={handleAgree}>
            規約に同意する
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
